import { Http } from "@/util";

export function getOssUploadRole() {
  return Http.get("/admin/upload/role/grant");
}

export function searchPlace(areaId, keyword) {
  return Http.get("/admin/common/place/search", { areaId, keyword });
}

export function reverseGeocoding(lat, lng) {
  return Http.get("/admin/common/reverse/geocoding", { lat, lng });
}
